import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Wrapper, Button } from './styles';
import { SWITCH_BUTTON } from './constants';
import { useTheme } from '@mui/material';

/**
 * Controlled toggle/tab component that switches between two options
 *
 * @param {string} labelLeft
 * @param {string} labelRight
 * @param {bool} checked - must be tracked by parent component. (this should be changed to something like 'left' - 'right' instead of a boolean).
 * @param {func} onClick - should include ability to modify `checked` state in parent.
 * @param {string} className
 */

const SwitchLabelButton = ({
  labelRight,
  labelLeft,
  checked,
  onClick,
  className,
  uiSettings,
}) => {
  const toggleClass = classnames({ checked, [SWITCH_BUTTON]: true });
  const { palette } = useTheme();

  return (
    <Wrapper
      className={[toggleClass, className]}
      borderRadius={uiSettings.dateFilter.toggle.borderRadius}
    >
      <Button
        fullWidth
        onClick={onClick}
        className={`${checked ? 'selected' : ''} toggleButton`}
        palette={palette}
      >
        {labelLeft}
      </Button>
      <Button
        fullWidth
        onClick={onClick}
        className={`${checked ? '' : 'selected'} toggleButton`}
        palette={palette}
      >
        {labelRight}
      </Button>
    </Wrapper>
  );
};

SwitchLabelButton.propTypes = {
  labelLeft: PropTypes.string.isRequired,
  labelRight: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  uiSettings: PropTypes.object,
};

export default SwitchLabelButton;
